"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const earnPointsInputs = [
  {
    name: "header",
    friendlyName: "Header",
    type: "string",
    required: true,
    defaultValue: "Earn points",
  },
  {
    name: "title",
    friendlyName: "Title",
    type: "string",
    required: true,
    defaultValue: "Earn more points",
  },
  {
    name: "details",
    friendlyName: "Details",
    type: "string",
    required: true,
    defaultValue: "Collect points on every online purchase or other tasks that earn points quick description",
  },
  {
    name: "subtitle",
    friendlyName: "Subtitle",
    type: "string",
    required: true,
    defaultValue: "How it works?",
  },
  {
    name: "subtitleDetails",
    friendlyName: "Subtitle Details",
    type: "string",
    required: true,
    defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sollicitudin et ex nec faucibus.",
  },
  {
    name: "pointsLabel",
    friendlyName: "Points label",
    type: "string",
    required: true,
    defaultValue: "points",
  },
  {
    name: "loadBaseItems",
    friendlyName: "Number of items to load initially",
    type: "number",
    required: true,
    min: 1,
    defaultValue: 5,
  },
  {
    name: "loadMoreItems",
    friendlyName: "Number of items to load on load more click",
    type: "number",
    min: 1,
    required: true,
    defaultValue: 10,
  },
  {
    name: "pointsList",
    friendlyName: "Points list",
    type: "list",
    required: true,
    subFields: [
      {
        name: "pointsCount",
        friendlyName: "Points count",
        type: "string",
        required: true,
      },
      {
        name: "pointsTitle",
        friendlyName: "Points title",
        type: "string",
        required: true,
      },
      {
        name: "pointsDescription",
        friendlyName: "Points description",
        type: "string",
        required: true,
      },
      {
        name: "pointsActionText",
        friendlyName: "Points action text",
        type: "string",
        required: true,
      },
      {
        name: "pointsActionTypeRadio",
        friendlyName: "Points action type",
        enum: ["button", "text"],
        type: "string",
        defaultValue: "button",
        required: true,
      },
      {
        name: "pointsLinkUrl",
        friendlyName: "Points action button url",
        type: "url",
        showIf: (options) => options.get("pointsActionTypeRadio") === "button",
      },
    ],
    defaultValue: [
      {
        pointsCount: "300",
        pointsTitle: "Christmas Special",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Coming soon",
        pointsActionTypeRadio: "text",
      },
      {
        pointsCount: "100",
        pointsTitle: "First purschase",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Shop now",
        pointsLinkUrl: "#",
        pointsActionTypeRadio: "button",
      },
      {
        pointsCount: "60",
        pointsTitle: "Invite a friend to join the Ploom Club",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Refer a friend",
        pointsLinkUrl: "#",
        pointsActionTypeRadio: "button",
      },
      {
        pointsCount: "30",
        pointsTitle: "Like our page on Facebook",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Like",
        pointsLinkUrl: "#",
        pointsActionTypeRadio: "button",
      },
      {
        pointsCount: "300",
        pointsTitle: "Christmas Special New",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Coming soon",
        pointsActionTypeRadio: "text",
      },
      {
        pointsCount: "100",
        pointsTitle: "First purschase New",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Shop now",
        pointsLinkUrl: "#",
        pointsActionTypeRadio: "button",
      },
      {
        pointsCount: "60",
        pointsTitle: "Invite a friend to join the Ploom Club New",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Refer a friend",
        pointsLinkUrl: "#",
        pointsActionTypeRadio: "button",
      },
      {
        pointsCount: "30",
        pointsTitle: "Like our page on Facebook New",
        pointsDescription: "Lorem ipsum dolor sit amet, consectetur.",
        pointsActionText: "Like",
        pointsLinkUrl: "#",
        pointsActionTypeRadio: "button",
      },
    ],
  },
  {
    name: "componentId",
    friendlyName: "Component ID",
    type: "string",
    defaultValue: "earnpoints",
  },
] as const satisfies Inputs;

export const EarnPointsComponent: RegisteredComponent = {
  name: "EarnPoints",
  component: dynamic(async () =>
    withValidation(earnPointsInputs, (await import("./EarnPoints")).EarnPoints, "EarnPoints")
  ),
  inputs: earnPointsInputs,
};
